<!--
 * @Description: 收入单回调
 * @Date: 2024-12-12 11:40:40
-->
<template>
  <div>确认收款跳转中...</div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import native from '@/utils/native';

onMounted(() => {
  setTimeout(() => {
    console.log('wallet');
    native.method.walletConfirmDone();
  }, 500);
});
</script>
